import { useTranslation } from 'react-i18next';
import { Controller, useWatch } from 'react-hook-form';

import { useAdvancedSearchFormContext } from '../../types';

import { NumberFieldWrapper } from './numberFieldWrapper';

export const BygningsnummerField = () => {
  const { t } = useTranslation();
  const label = t('search.advanced.field_bygningsnummer');
  const { control, trigger } = useAdvancedSearchFormContext();
  const gardsnummer = useWatch({ control, name: 'gardsnummer' });
  const bruksnummer = useWatch({ control, name: 'bruksnummer' });

  return (
    <Controller
      rules={{
        validate: {
          required: (value) => {
            //Message vil be filtered out and replaced with custom error message in the error summary
            const errorMessage = 'Bygningsnummer er påkrevd';
            // Ensure that either this value or gardsnummer and bruksnummer is provided if this value is not
            if (!value && !(gardsnummer && bruksnummer)) {
              return errorMessage;
            }
            return true;
          }
        }
      }}
      control={control}
      name="bygningsnummer"
      render={({ field: { onChange, ...rest }, fieldState, formState }) => (
        <NumberFieldWrapper
          fieldLabel={label}
          error={!!fieldState.error}
          onValueChange={(_, e) => {
            onChange(e.event);

            if (formState.isSubmitted) {
              trigger(['bruksnummer', 'gardsnummer']);
            }
          }}
          {...rest}
        />
      )}
    />
  );
};
